import './metrics_view.js.coffee'
Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.InstagramMetricsView extends Monitoring.Reports.DailyInsights.MetricsView
  template: JST['backbone/templates/monitoring/reports/daily_insights/instagram_metrics']

  initialize: (@options = {}) =>
  	@$el.addClass('ig-metrics')
  	super(@options)
